import { MARKET_CHART_COLORS } from './marketDataUtils';

function buildMarketChartOptions({ chartId, dates = [], height = 420 }) {
  const labelCount = dates.length;
  const labelStep = Math.max(1, Math.ceil(labelCount / 6));

  return {
    chart: {
      id: chartId,
      height,
      animations: {
        enabled: false
      },
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      },
      selection: {
        enabled: false
      },
      fontFamily: 'inherit'
    },
    stroke: {
      width: 2.5,
      curve: 'straight'
    },
    colors: MARKET_CHART_COLORS,
    grid: {
      borderColor: '#e9ecef',
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: false
        }
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      fontSize: '13px',
      markers: {
        width: 10,
        height: 10,
        radius: 2
      }
    },
    xaxis: {
      categories: dates,
      labels: {
        show: true,
        rotate: -45,
        rotateAlways: false,
        hideOverlappingLabels: true,
        style: {
          fontSize: '11px',
          colors: '#6c757d'
        },
        formatter: (value, timestamp, opts) => {
          const index = opts?.i ?? dates.indexOf(value);
          if (index < 0) {
            return value;
          }
          if (index % labelStep !== 0 && index !== labelCount - 1) {
            return '';
          }
          return value;
        }
      },
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false
      }
    },
    yaxis: {
      opposite: true,
      labels: {
        formatter: (value) => `${value.toFixed(0)}%`,
        style: {
          colors: '#6c757d'
        }
      }
    },
    annotations: {
      yaxis: [{
        y: 0,
        borderColor: '#adb5bd',
        borderWidth: 1,
        strokeDashArray: 4,
        opacity: 0.6
      }]
    },
    markers: {
      size: 0,
      hover: {
        size: 5
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      x: {
        show: true,
        formatter: (value, { dataPointIndex }) => {
          if (dataPointIndex >= 0 && dataPointIndex < dates.length) {
            return dates[dataPointIndex];
          }
          return value;
        }
      },
      y: {
        formatter: (value) => {
          if (value == null || Number.isNaN(Number(value))) {
            return null;
          }
          return `${Number(value).toFixed(2)}%`;
        }
      }
    }
  };
}

export default buildMarketChartOptions;
